/**
 * Reading a failed `PUT /registration/session/:id`.
 *
 * `req` rejects with the parsed API body, whose shape is not typed at the call
 * site. A 410 means the session is gone and cannot be recovered in place;
 * `invalid_fields.registration_step` carries the server's reason when it
 * refuses the step itself. Narrowed field by field rather than cast, so a
 * rejection of any other shape reads as "nothing known".
 */

export interface SessionUpdateFailure {
  status: number | undefined
  stepMessage: string | undefined
}

export const readSessionUpdateError = (
  error: unknown
): SessionUpdateFailure => {
  if (typeof error !== 'object' || error === null) {
    return { status: undefined, stepMessage: undefined }
  }
  const status =
    'status' in error && typeof error.status === 'number'
      ? error.status
      : undefined
  const fields =
    'invalid_fields' in error &&
    typeof error.invalid_fields === 'object' &&
    error.invalid_fields !== null
      ? error.invalid_fields
      : null
  const stepMessage =
    fields !== null &&
    'registration_step' in fields &&
    typeof fields.registration_step === 'string'
      ? fields.registration_step
      : undefined
  return { status, stepMessage }
}
